import { Resource } from '../../../http/resource/resource.model';
// tslint:disable: variable-name

export class ButtonActions extends Resource {
    uri: string;
    step_id: number;
    feedBack_id: number;
    stage_id: number;
    person_id: number;
    applyment_id: number;
    close_popup: number;

    button_id: number;
    data: any;

    link: string;
    new_tab: number;
    place_id: number;
    place_type_id: number;

    last_place_id: string;
    last_place_type_id: string;

    token: string;
    selective_process_id: number;
}
